export const brandPalette = Object.freeze({
  primary: '#005983',
  primaryHover: '#00486A',
  text: '#434343',
  surface: '#E9ECF1',
  white: '#FFFFFF',
  success: '#31705E',
  warning: '#F68313',
  accent: '#282657'
});

export const brandSupportColors = Object.freeze({
  danger: '#D81212',
  info: '#D3E9FA',
  border: '#DFE2E8',
  muted: '#666666'
});

export const brandTypography = Object.freeze({
  fontFamily: {
    body: 'Calibri, "Segoe UI", sans-serif',
    heading: 'Calibri, "Segoe UI", sans-serif',
    mono: 'source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace'
  },
  fontWeight: {
    regular: 400,
    bold: 700
  },
  fontStyle: {
    normal: 'normal',
    italic: 'italic'
  },
  fontSize: {
    root: '10px',
    body: '1.8rem',
    paragraph: '2rem',
    footnote: '1.5rem',
    introduction: '2.4rem',
    large: '4rem',
    mega: '5.4rem',
    h1: '5rem',
    h2: '4.2rem',
    h3: '3rem',
    button: '2rem'
  },
  lineHeight: {
    body: 1.33,
    heading: 1.15,
    compactHeading: 1.1,
    mega: 1.111,
    control: 1.25
  },
  responsiveRootSize: {
    desktop: '10px',
    compact: '9px',
    mobile: '8px'
  }
});

export const brandingDefaults = Object.freeze({
  logo_url: null,
  primary_color: brandPalette.primary,
  secondary_color: brandPalette.accent,
  success_color: brandPalette.success,
  danger_color: brandSupportColors.danger,
  warning_color: brandPalette.warning,
  info_color: brandSupportColors.info,
  background_color: brandPalette.white,
  text_color: brandPalette.text
});

export const brandCssVariables = Object.freeze({
  '--brand-primary-hover': brandPalette.primaryHover,
  '--brand-surface': brandPalette.surface,
  '--brand-border': brandSupportColors.border,
  '--brand-muted': brandSupportColors.muted,
  '--brand-font-body': brandTypography.fontFamily.body,
  '--brand-font-heading': brandTypography.fontFamily.heading,
  '--brand-font-mono': brandTypography.fontFamily.mono,
  '--brand-font-weight-regular': String(brandTypography.fontWeight.regular),
  '--brand-font-weight-bold': String(brandTypography.fontWeight.bold),
  '--brand-font-size-root': brandTypography.fontSize.root,
  '--brand-font-size-body': brandTypography.fontSize.body,
  '--brand-font-size-paragraph': brandTypography.fontSize.paragraph,
  '--brand-font-size-footnote': brandTypography.fontSize.footnote,
  '--brand-font-size-introduction': brandTypography.fontSize.introduction,
  '--brand-font-size-large': brandTypography.fontSize.large,
  '--brand-font-size-mega': brandTypography.fontSize.mega,
  '--brand-font-size-h1': brandTypography.fontSize.h1,
  '--brand-font-size-h2': brandTypography.fontSize.h2,
  '--brand-font-size-h3': brandTypography.fontSize.h3,
  '--brand-font-size-button': brandTypography.fontSize.button,
  '--brand-line-height-body': String(brandTypography.lineHeight.body),
  '--brand-line-height-heading': String(brandTypography.lineHeight.heading),
  '--brand-line-height-heading-compact': String(brandTypography.lineHeight.compactHeading),
  '--brand-line-height-mega': String(brandTypography.lineHeight.mega),
  '--brand-line-height-control': String(brandTypography.lineHeight.control)
});